module.exports = __webpack_public_path__ + "static/average-5e0037ccba01507f57fe24db3cdd2b6c.jpg";